import { MessageCircle } from "lucide-react";

export const POUSADA_WHATSAPP = "5511914175095";

export function buildWaLink(phone, text) {
  const digits = String(phone || "").replace(/\D/g, "");
  // Se número do hóspede não tiver DDI, presume Brasil (+55). Se estiver vazio, usa o número da pousada.
  let target = digits;
  if (!target) target = POUSADA_WHATSAPP;
  else if (target.length <= 11) target = "55" + target;
  const encoded = encodeURIComponent(text || "");
  return `https://wa.me/${target}?text=${encoded}`;
}

export function FloatingWhatsApp() {
  const message = "Olá! Gostaria de informações sobre reservas nas pousadas da rede Serra Stays.";
  const href = `https://wa.me/${POUSADA_WHATSAPP}?text=${encodeURIComponent(message)}`;
  return (
    <a
      data-testid="floating-whatsapp"
      href={href}
      target="_blank"
      rel="noreferrer"
      title="Falar no WhatsApp"
      aria-label="Falar no WhatsApp"
      className="fixed bottom-24 lg:bottom-6 right-6 z-50 w-14 h-14 rounded-full bg-[#25D366] text-white flex items-center justify-center shadow-lg hover:scale-105 hover:bg-[#1ebe57] transition-transform"
    >
      <MessageCircle size={26} strokeWidth={1.8} />
    </a>
  );
}
